/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TransactionActions from 'login/components/Transaction/TransactionActions/TransactionActions.jsx';
import TransactionProgression from 'login/components/Transaction/TransactionProgression/TransactionProgression.jsx';
import { ApolloProvider } from '@apollo/client';
import { ApolloClient } from '@sm360/widget-commons-general';

import 'login/components/Transaction/TransactionDetails/TransactionDetails.scss';

class TransactionDetails extends Component {
    render() {
        const {
            showTransactionDetails,
            onCloseTransactionAction,
            isNewEnabled,
            isUsedEnabled,
            usedUrl,
            vehicleTradein,
            isAuthenticated,
            loginClick,
            completedSteps,
            savedTime,
            deleteTradeIn,
            isMultiDealerGarage,
            hasAdobeTagging,
            displayCreditRate,
        } = this.props;

        const classAnimDetails = showTransactionDetails ? 'is-visible' : '';
        return (
            <ApolloProvider client={ApolloClient.getOrCreate()}>
                <div className={`TransactionDetails--wrapper ${classAnimDetails}`}>
                    <TransactionActions
                        completedSteps={completedSteps}
                        showTransactionDetails={showTransactionDetails}
                        onCloseTransactionAction={onCloseTransactionAction}
                        isNewEnabled={isNewEnabled}
                        isUsedEnabled={isUsedEnabled}
                        usedUrl={usedUrl}
                        isAuthenticated={isAuthenticated}
                        loginClick={loginClick}
                        vehicleTradein={vehicleTradein}
                        deleteTradeIn={deleteTradeIn}
                        isMultiDealerGarage={isMultiDealerGarage}
                        hasAdobeTagging={hasAdobeTagging}
                        displayCreditRate={displayCreditRate}
                    />
                    <TransactionProgression
                        savedTime={savedTime}
                        showTransactionDetails={showTransactionDetails}
                        isAuthenticated={isAuthenticated}
                    />
                </div>
            </ApolloProvider>
        );
    }
}

TransactionDetails.defaultProps = {
    completedSteps: {
        garageCount: 0,
        garage: false,
        tradein: false,
        finance: false,
        reserve: false,
    },
    hasAdobeTagging: false,
    displayCreditRate: false,
};

TransactionDetails.propTypes = {
    completedSteps: PropTypes.shape({
        garageCount: PropTypes.number.isRequired,
        garage: PropTypes.bool.isRequired,
        tradein: PropTypes.bool.isRequired,
        finance: PropTypes.bool.isRequired,
        reserve: PropTypes.bool.isRequired,
    }),
    showTransactionDetails: PropTypes.bool.isRequired,
    onCloseTransactionAction: PropTypes.func.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    vehicleTradein: PropTypes.shape({
        tradeId: PropTypes.string.isRequired,
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
        modelTrim: PropTypes.string.isRequired,
        year: PropTypes.number.isRequired,
        odometer: PropTypes.number.isRequired,
        retail: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
        officialAmount: PropTypes.number.isRequired,
        officialAmountExp: PropTypes.number.isRequired,
    }).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    loginClick: PropTypes.func.isRequired,
    savedTime: PropTypes.number.isRequired,
    deleteTradeIn: PropTypes.func.isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
    displayCreditRate: PropTypes.bool,
};

TransactionDetails.displayName = 'TransactionDetails';

export default TransactionDetails;
